import './_bootstrap.js';


(function ($, Drupal) {

  'use strict';
  let uw_brackpoint = new Object();
  uw_brackpoint = {     // объект
    md: 480,
    lg: 768,
    xl: 1269,
    xxl: 1450
  }

  function handleAnchorLinkClick(target, value) {
    var targetOffset = $(target).offset().top;
    $('html, body').animate({ scrollTop: targetOffset }, 100);
    $('.form-select.custom-select option').removeAttr('selected', '');
    $('.form-select.custom-select option[value="' + value + '"]').attr('selected', 'selected');
    return false;
  }
  // // Enable Bootstrap Popover sitewide.
  // // Popovers are opt-in for performance reasons.
  // Drupal.behaviors.bsPopover = {
  //   attach: function (context) {
  //     $('[data-bs-toggle="popover"]').popover();
  //   }
  // };

  // // Enable Bootstrap Toast sitewide.
  // // Toasts are opt-in for performance reasons.
  // Drupal.behaviors.bsToast = {
  //   attach: function (context) {
  //     $('.toast').toast('show');
  //   }
  // };
  Drupal.behaviors.uworld = {
    attach: function (context) {
      var checkbox = document.querySelectorAll('input[name=mode]');

      $(window).on("load", function () {
        $("#page-preloader").addClass("done");
      });
      if (!Drupal.behaviors.uworld.initialized) {
        // Инициализация скриптов
        $('a[href="#vac-anchor"]').click(function () {
          return handleAnchorLinkClick('.vakansii__field-dobavit-formu', 'Администратор');
        });

        $('a[href="#stom-anchor"]').click(function () {
          return handleAnchorLinkClick('.vakansii__field-dobavit-formu', 'Врач-стоматолог детский');
        });

        $('a[href="#asis-anchor"]').click(function () {
          return handleAnchorLinkClick('.vakansii__field-dobavit-formu', 'Ассистент врача-стоматолога');
        });

        $('a[href="#stom-ort-anchor"]').click(function () {
          return handleAnchorLinkClick('.vakansii__field-dobavit-formu', 'Врач-стоматолог ортопед');
        });

        $('a[href="#stom-tarap-anchor"]').click(function () {
          return handleAnchorLinkClick('.vakansii__field-dobavit-formu', 'Врач стоматолог-терапевт');
        });

        $('a[href="#stom-hir-anchor"]').click(function () {
          return handleAnchorLinkClick('.vakansii__field-dobavit-formu', 'Врач-стоматолог хирург, имплантолог');
        });

        // Установка флага, что скрипты уже инициализированы
        Drupal.behaviors.uworld.initialized = true;
      }
      // Обработчики кликов на ссылки


      $(".change_theme").each(function (index) {

        $(this).find("label").attr("for", "switch" + index)
        $(this).find("input").attr("id", "switch" + index)
        // console.log(index)
        checkbox[index].addEventListener('change', function () {
          if (this.checked) {
            trans()
            document.documentElement.setAttribute('data-theme', 'dark')
            $.cookie('theme', 'dark');
          }
          else {
            trans()
            document.documentElement.setAttribute('data-theme', 'light')
            $.cookie('theme', 'light');
          }
        })
      })
      // if ($(".form-select").length > 0 ){
      //   $(".form-select").parent().on("click", function(){
      //     $(this).find("select.form-select").trigger('mousedown')
      //   })
      // }
      if ($.cookie('theme') !== undefined && $.cookie('theme') === 'dark') {
        document.documentElement.setAttribute('data-theme', 'dark')
        $(".change_theme input[type=checkbox]").prop('checked', true);
      }
      else {
        document.documentElement.setAttribute('data-theme', 'ligth')
      }

      let trans = () => {
        document.documentElement.classList.add('transition');
        window.setTimeout(() => {
          document.documentElement.classList.remove('transition');
        }, 300)
      }

      if ($('[type="tel"]').length > 0) {
        $('[type="tel"]').mask('+ 0 (000) 000 00 00')
      }

      let prev = `
           <div class="slick-prev container">
            <div class="row">
              <div class="offset-10 col-1 ">
                  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle opacity="0.05" cx="26" cy="26" r="26" fill="#202124"/>
                    <path d="M33.5 26L18.5 26" stroke="#202124" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M23.5 21L18.5 26L23.5 31" stroke="#202124" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </div>
              </div>
            </div>`
      let next = `<div class="slick-next container">
              <div class="row">
              <div class="offset-11 col-1">
                  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle opacity="0.05" cx="26" cy="26" r="26" fill="#202124"/>
                    <path d="M18.5 26H33.5" stroke="#202124" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M28.5 31L33.5 26L28.5 21" stroke="#202124" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
               </div>
              </div>
            </div>`

      if ($('[for=edit-field-tip-otzyva-value]').length > 0) {
        $('[for=edit-field-tip-otzyva-value] + select > option[value="All"] ').html($('[for=edit-field-tip-otzyva-value]').text())
        $('[for=edit-field-tip-otzyva-value]').hide()
      }
      if ($('[for=edit-field-napravlenie-dlya-filtra-value]').length > 0) {
        $('[for=edit-field-napravlenie-dlya-filtra-value] + select > option[value="All"] ').html($('[for=edit-field-napravlenie-dlya-filtra-value]').text())
        $('[for=edit-field-napravlenie-dlya-filtra-value]').hide()

      }

      $(".mob-title .close").on("click", function () {
        $(".navbar-toggler").trigger("click")
      })

      // $(".change_theme input[type=checkbox]").change(function () {
      //   if ($(".change_theme input[type=checkbox]").checked) {
      //     $("#txtAge").show();
      //   }
      //   else {
      //     $("#txtAge").hide();
      //   }
      // })
      $('.li-uslugi .uw-menu-uslugi').unbind('click');
      $('.navbar-text .uw-unbind-click-menu').unbind('click');

      // $(".nav.navbar-nav .dropdown a, .nav.navbar-nav .dropdown", context).once('uworld').on("click.myclick", function () {
      //   if ($("body").width() < 1260) {
      //     // console.log($(this).next().prop("tagName"),
      //     // $(this).hasClass("firstclick"))
      //     // console.log(($(this).next().prop("tagName") === 'DIV' &&
      //     // !$(this).hasClass("firstclick")), $(this).next().prop("tagName")
      //     // === 'DIV', $(this).hasClass("firstclick") !== false)

      //     if ($(this).next().find("a").length > 0 && !$(this).hasClass("firstclick")) {
      //       event.preventDefault();
      //       $(this).unbind(".myclick");
      //       // return false
      //       // $(this).addClass("firstclick")
      //     }
      //     else {
      //       location.href = $(this).attr("href")
      //     }
      //   }
      //   else {
      //     location.href = $(this).attr("href")
      //   }

      // })

      $(document).ready(function() {
        $('.navbar-toggler').click(function() {
          $('navbar-collapse').hasClass('show');
          $('body').toggleClass('clicked-mob-menu');
        })
      })


      if ($('.front-slider__field-slide').length > 0) {
        $('.front-slider__field-slide', context).once('uworld').slick({
          prevArrow: prev,
          nextArrow: next,
          dots: true,
          infinite: true,
          speed: 500,
          fade: true,
          swipeToSlide: true,
          cssEase: 'linear',
          dotsClass: 'custom_paging',
          customPaging: function (slider, i) {
            return (i + 1) + ' <svg width="48" height="2" viewBox="0 0 48 2" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.5" width="48" height="1" fill="#202124"/></svg> ' + slider.slideCount;
          }
        })
      }
      if ($(".front-slider-doctors").length > 0) {
        $(".front-slider-doctors .wrap-slider-doctors", context).once('uworld').slick({
          // arrows: true,
          prevArrow: prev,
          nextArrow: next,
          slidesToShow: 3,
          slidesToScroll: 1,
          swipeToSlide: true,
          infinite: true,

          responsive: [
            {
              breakpoint: uw_brackpoint.xxl,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: uw_brackpoint.xl,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,

              }
            },
            {
              breakpoint: uw_brackpoint.lg,
              settings: {
                slidesToShow: 1
              }
            }
          ],
          customPaging: function (slider, i) {
            return (i + 1) + ' <svg width="48" height="2" viewBox="0 0 48 2" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.5" width="48" height="1" fill="#202124"/></svg> ' + slider.slideCount;
          }

        })
      }

      $('.certificates__field-certificate', context).once('uworld').slick({
        // arrows:true,
        prevArrow: prev,
        nextArrow: next,
        dots: true,
        infinite: false,
        adaptiveHeight: true,
        variableWidth: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        dotsClass: 'custom_paging',
          customPaging: function (slider, i) {
            return (i + 1) + ' <svg width="48" height="2" viewBox="0 0 48 2" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.5" width="48" height="1" fill="#202124"/></svg> ' + slider.slideCount;
          },
        responsive: [
          {
            breakpoint: uw_brackpoint.xxl,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: uw_brackpoint.xl,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: uw_brackpoint.lg,
            settings: {
              slidesToShow: 1
            }
          }
        ]


      });


      $('.doctors-education__field-add-edu-item', context).once('uworld').slick({
        prevArrow: prev,
        nextArrow: next,
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        adaptiveHeight: false,
        variableWidth: true,
        swipeToSlide: true,
        slidesToScroll: 2,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: uw_brackpoint.xl,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: uw_brackpoint.lg,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: uw_brackpoint.md,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });


      $('.primery-rabot__field-photo-befor-after', context).once('uworld').slick({
        arrows:true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        swipeToSlide: true,

      });
      $('.primery-rabot__field-add-primer-rabot-before-af', context).once('uworld').slick({
        arrows:true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        swipeToSlide: true,

      });



      $('.our-equipment__field-add-item-', context).once('uworld').slick({
        dots: false,
        infinite: true,
        // centerMode: true,
        // centerPadding: '40px',
        speed: 200,
        slidesToShow: 3,
        swipeToSlide: true,
        initialSlide: 2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: uw_brackpoint.xxl,
            settings: {
              // centerMode: true,
              // centerPadding: '20px',
              // variableWidth: true,
              slidesToShow: 3,
            }
          },
          {
            breakpoint: uw_brackpoint.xl,
            settings: {
              infinite: true,
              centerMode: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1
            }
          },
          {
            breakpoint: uw_brackpoint.lg,
            settings: {
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1,
              centerMode: true,
              centerPadding: '1px',
            }
          },
          {
            breakpoint: uw_brackpoint.md,
            settings: {
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              centerMode: true,
              centerPadding: '10px',
              variableWidth: true,
            }
          },
          {
            breakpoint: 555,
            settings: {
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '0',
            }
          },
          {
            breakpoint: 465,
            settings: {
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '40px',
            }
          }

        ]
      });

      $('.wrap-slider-doctors', context).once('uworld').slick({
        arrows:true,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: true,
        responsive: [
          {
            breakpoint: uw_brackpoint.xxl,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: uw_brackpoint.xl,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: uw_brackpoint.lg,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });

      $('.uw-slick ul', context).once('uworld').slick({
        dots: true,
        infinite: true,
        speed: 200,
        slidesToShow: 1,
        fade: true,
        cssEase: 'ease-in-out',
        touchThreshold: 100
      });
      $(' .path-frontpage .artic-front-block', context).once('uworld').slick({
        arrows:true,
        dots: false,
        infinite: true,
        speed: 200,
        slidesToShow: 3,
        swipeToSlide: true,
        // mobileFirst: true,
        variableWidth:true,
        responsive: [
          {
            breakpoint: uw_brackpoint.xxl,
            settings: {
              slidesToShow: 3,
              variableWidth:false,
            }
          },
          {
            breakpoint: uw_brackpoint.xl,
            settings: {
              slidesToShow: 2,
              variableWidth:false,
            }
          },
          {
            breakpoint: uw_brackpoint.lg,
            settings: {
              variableWidth:false,
              slidesToShow: 1
            }
          },
          {
            breakpoint: uw_brackpoint.md,
            settings: {
              centerMode:true,
              variableWidth:true,
              slidesToShow: 1
            }
          }
        ]
      });

      $(document).ready(function () {
        if($("body.path-doctors").length > 0){
          $("body.path-doctors .doctor--teaser").on("click", function(){
              location.href = $(this).find(".doctor__field-imya a").attr("href")
          })
        }
        if($("body.path-frontpage").length > 0){
          $("body.path-frontpage .doctor--teaser-for-slider").on("click", function(){
              location.href = $(this).find(".doctor__field-imya a").attr("href")
          })
        }
        if($("body.page-node-type-doctor").length > 0){
          $("body.page-node-type-doctor .doctor--teaser-for-slider").on("click", function(){
              location.href = $(this).find(".doctor__field-imya a").attr("href")
          })
        }
        if($("body.path-taxonomy").length > 0){
          $("body.path-taxonomy .event--teaser").on("click", function(){
              location.href = $(this).find(".wrapper-body-teaser .event__field-title-teaser-event a ").attr("href")
          })
        }
        if($("body.page-node-type-event").length > 0){
          $("body.page-node-type-event .event--teaser").on("click", function(){
              location.href = $(this).find(".wrapper-body-teaser .event__field-title-teaser-event a ").attr("href")
          })
        }



        var button = $('#button-up');
        $(window).scroll(function () {
          if ($(this).scrollTop() > 300) {
            button.fadeIn();
          }
          else {
            button.fadeOut();
          }
        });
        button.on('click', function () {
          $('body, html').animate({
            scrollTop: 0
          }, 5);
          return false;
        });
      });



      $(function() {
        var header = $(".navbar");
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 200) {
                header.removeClass('navbar-light').addClass("navbar-background");
            } else {
                header.removeClass("navbar-background").addClass('navbar-light');
            }
        });
    });

    $(document).ready(function () {
       $('.form-checkbox').prop('checked', true);
     });

       $(document).ready(function($) {
      $("#edit-gruppa-voprosov-target-id li").click(function() {
        location.href = $(this).find (" a ").attr("href");
       });
     });

     $(document).ready(function($) {
      $(".novost--teaser").click(function() {
        location.href = $(this).find (".novost__field-podrobnee-ssylka a ").attr("href");
       });
     });

     $(document).on('click', '.video-block__field-text a', function(event) {
      event.preventDefault();
      $(".video-block__field-video img").click();
     });



    $(".price-for-direction__field-price-on-id .paragraph--type--price").each(function(){
      if($(this).text().trim() == ""){
        $(this).hide()
      }
     })

    //  $('.paragraph--type--webform-with-doc-photo').each(function(){
    //   if($(".webform-with-doc-photo__field-indent-down").text() == ""){
    //     $(".paragraph--type--webform-with-doc-photo").addClass('margin-down');
    //   }
    // });



    $('.paragraph--type--webform-with-doc-photo').each(function(){
      if($(".webform-with-doc-photo__field-indent-down").text() == ""){
        $(".paragraph--type--webform-with-doc-photo").addClass('margin-down');
      }
    });

    $('.paragraph--type--webform-with-doc-photo').each(function(){
      if($(".webform-with-doc-photo__field-indent-up").text() == ""){
        $(".paragraph--type--webform-with-doc-photo").addClass('margin-up');
      }
    });


     $(".view-meropriyatiya .views-row .event__field-specialnosti-tizer").each(function(){
       $(this).parent().css("margin-top",( $(this).height() + 16) / 2 * -1 )

     })



    $('.programma__field-cvet-teksta-knopka').each(function(){
      var textcolor = $('.programma__field-cvet-teksta-knopka').text();
      $('.programma__field-lin').css({"background-color": textcolor });
      // $('.path-programs .nav-item ').css({"background-color": textcolor });
    });

    }
  }




})(jQuery, Drupal);
